/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de reimpresion de caja.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
* ---------------------------------------------------------------------------------------
*/

import FrmReimpresionCaja from "../../administracion/FrmReimpresionCaja.jsx";
import SizeSoftXFrmPortatil from "../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmReimpresionCajaPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmReimpresionCaja">
      <FrmReimpresionCaja />
    </SizeSoftXFrmPortatil>
  );
}
